export default "__VITE_PUBLIC_ASSET__8b5f4082__"